import type { NotificationObject } from "./notificationMaker";

const UNKNOWN_CONTEXT_LABEL = "contexto desconocido";
export const NOTIFICATION_RANGE_HOURS = 24 * 7;

export const buildNotificationTarget = (notification: NotificationObject): string | null => {
  const contextId = notification.contextName?.trim();
  if (!contextId || contextId.toLowerCase() === UNKNOWN_CONTEXT_LABEL) {
    return null;
  }

  const params = new URLSearchParams({ context: contextId });
  const alertDate = notification.recvTime ? new Date(notification.recvTime) : null;
  if (alertDate && !Number.isNaN(alertDate.getTime())) {
    params.set("alertAt", alertDate.toISOString());
    params.set("rangeHours", String(NOTIFICATION_RANGE_HOURS));
  }
  if (notification.attributeKey?.trim()) {
    params.set("attribute", notification.attributeKey.trim());
  }
  return `/dashboard?${params.toString()}`;
};
